module.exports = __webpack_public_path__ + "static/media/arrow-to-right.226c48fe.svg";